import React from "react";
import bannerdipolma from "../../../../Assets/Courses/MakeUp.png";
const BeautyMakeup = () => {
  return (
    <>
      <div className="w-full h-auto">
        <img
          src={bannerdipolma}
          alt="bannerdipolma"
          className="w-full h-full "
        />
      </div>
      <div className="w-full bg-white py-12 px-4 md:px-10">
        <div className="w-full mx-auto flex flex-col md:flex-row items-center gap-8 pb-10">
          {/* Right Text Section */}
          <div className="w-full md:w-[60%]">
            <h5 className="text-3xl md:text-4xl font-semibold text-black leading-snug mb-4 heading">
              Explore The Artistry Of Beauty And Make-Up
            </h5>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed text-justify sub-heading">
              Dive into a world of beauty mastery on our accessible platform.
              From foundational principles to advanced techniques, our
              expert-led tutorials cater to all skill levels. Join our vibrant
              community of makeup enthusiasts, where creativity knows no bounds.
              Embrace the artistry of makeup and unlock your full potential with
              us. Start your journey today and let your beauty shine brighter
              than ever before.
            </p>
            {/* Section Divider Content Below */}
            <div className="max-w-5xl mx-auto mt-12 space-y-6 text-gray-700 text-justify heading">
              <h3 className="text-2xl md:text-3xl font-semibold text-black mb-4">
                Unveiling The Secrets Of Glamour And Elegance
              </h3>

              <p className="text-base md:text-lg leading-relaxed sub-heading">
                Unlock the door to a world of beauty and sophistication with our
                comprehensive Beauty and Make-Up course. Designed for aspiring
                make-up artists, beauty enthusiasts, and professionals seeking
                to enhance their skills, this course is your gateway to
                mastering the artistry of cosmetics application.
              </p>

              <p className="text-base md:text-lg leading-relaxed sub-heading">
                Embark on a journey where creativity meets technique as you
                delve into the intricate world of beauty and make-up. From
                mastering the fundamentals of skincare to understanding color
                theory and application techniques, each module is meticulously
                crafted to empower you with the knowledge and skills needed to
                create stunning looks for any occasion.
              </p>

              <p className="text-base md:text-lg leading-relaxed sub-heading">
                Under the guidance of industry experts and seasoned
                professionals, you'll learn the latest trends, techniques, and
                tools used in the world of beauty. Whether you dream of working
                backstage at fashion shows, creating captivating bridal looks,
                or launching your own make-up line, this course equips you with
                the expertise to turn your passion into a fulfilling career.
              </p>

              <p className="text-base md:text-lg leading-relaxed sub-heading">
                Join us and elevate your beauty game to new heights. Unleash
                your creativity, refine your skills, and embark on a journey of
                self-expression through the transformative power of beauty and
                make-up.
              </p>
            </div>
          </div>
          {/* Left Image Section */}
          <div className="w-full md:w-[40%] h-fit md:sticky md:top-24 self-start">
            <img
              src="https://www.insdjaipur.com/images/Untitled%20design%20(10).png"
              alt="Beauty and Makeup"
              className="w-full h-[400px] object-cover"
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-12 ">
          {/* Heading Section */}
          <div className="mx-auto text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 heading heading">
              Career Paths
            </h2>
            <p className="text-lg text-gray-600 sub-heading sub-heading">
              Explore the exciting opportunities that await you
            </p>
          </div>

          {/* Card Section */}
          <div className="w-full mx-auto flex flex-col lg:flex-row gap-8 items-stretch">
            {/* Left Column */}
            <div className="w-full">
              <div className="p-8 h-full">
                <h3 className="text-2xl font-bold text-[#144982] mb-6 border-b-4 border-[#DA3335] pb-3 inline-block heading">
                  Your Future Awaits
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sub-heading">
                  {/* Card 1 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI / UX Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Researcher
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI/UX Developer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 4 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Strategist
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 5 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 6 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Service Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 7 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 8 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Product Designer
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeautyMakeup;
